import { render, staticRenderFns } from "./MidControl.vue?vue&type=template&id=2037e5b6&scoped=true&"
import script from "./MidControl.vue?vue&type=script&lang=js&"
export * from "./MidControl.vue?vue&type=script&lang=js&"
import style0 from "./MidControl.vue?vue&type=style&index=0&id=2037e5b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037e5b6",
  null
  
)

export default component.exports